import { BaseApi } from '.';


export const SolarRgbImageApi = {
  getSolarRgbImage,
  getRgbImageAltitudes
};

function getSolarRgbImage(imageId){
  return BaseApi.get(`/solarRgbImages/${imageId}`);
}

function getRgbImageAltitudes(reportId, axiosConfig){
  return BaseApi.get(`/solarRgbImages/reportId/${reportId}/altitudes`, axiosConfig);
}
